module.exports = __webpack_public_path__ + "static/media/06.c2e58291.wav";